import { isToday, isWeekend } from "date-fns";
import React from "react";
import { BaseComponent } from '../core/BaseComponent';

interface MonthDayProps {
    date: Date;
    width: string;
    classes?: string[];
}

export class MonthDay extends BaseComponent<MonthDayProps> {
    getClassName(): string {
        let classes = ["dagcellHeader", "center"];
        const date = this.props.date;
        if (isWeekend(date))
            classes.push("weekend");
        if (isToday(date))
            classes.push("today");

        if (this.props.classes) {
            classes = classes.concat(this.props.classes);
        }
        return classes.join(" ");
    }
    render() {
        return <td className={this.getClassName()} style={{ width: this.props.width }}>
            {this.props.children}
        </td>;
    }
}
